import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { DARCKBORDER } from '../../../helpers/Config';

const CustomTextField = styled((props) => <TextField {...props} />)(({ theme }) => ({
  borderRadius: '31px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '31px',
    '& fieldset': {
      borderColor: '#DFE5EF', // Default border color
    },
    '&:hover fieldset': {
      borderColor: 'rgba(156, 163, 175, 0.8)', // Hover border color
    },
    '&.Mui-focused fieldset': {
      borderColor: DARCKBORDER, // Focus border color
      borderWidth: '1px', // Optional: Custom border width on focus
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'rgba(156, 163, 175, 1)', // Placeholder text color
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px',
    opacity: '1',
  },
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: 'rgba(156, 163, 175, 1)', // Placeholder text color
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px',
    opacity: '1',
  },
  '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '1',
  },
  '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200],
  },
  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px white inset', // Змінює фон на білий
    transition: 'background-color 5000s ease-in-out 0s', // Знімає анімацію
  },
}));

export default CustomTextField;
